import React from 'react';
import tabexlogo from './Generalfiles/images/tabexlogo.png';
import styles from './Pagepreloader.module.css';

const Pagepreloader = ({ label = 'Loading', showLabel = false, fullPage = false, size = 'default', className = '' }) => {
    const sizeClass = size === 'inline' ? styles.sizeInline : size === 'compact' ? styles.sizeCompact : styles.sizeDefault;

    return (
        <div
            className={`${styles.wrap} ${sizeClass} ${fullPage ? styles.fullPage : ''} ${className}`.trim()}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className={styles.stage}>
                <span className={styles.glow} aria-hidden="true" />
                <div className={styles.logoFrame}>
                    <img src={tabexlogo} alt="Tabex" className={styles.logo} draggable="false" />
                    <span className={styles.shimmer} aria-hidden="true" />
                </div>
                {size !== 'inline' && (
                    <div className={styles.barTrack} aria-hidden="true">
                        <span className={styles.barFill} />
                    </div>
                )}
                {showLabel && <p className={styles.label}>{label}</p>}
                <span className={styles.visuallyHidden}>{label}</span>
            </div>
        </div>
    );
};

export default Pagepreloader;
